import React from 'react';
import {getAppData, getEnvironment} from '../../appsInfo/appsInfo.js';
import AppCard from '../AppCard/AppCard';

import createAbsoluteGrid from 'react-absolute-grid';

// Pass your display component to create a new grid
const AbsoluteGrid = createAbsoluteGrid (AppCard);

const AppGrid = ({type}) => {
  const env = getEnvironment (window.location.host);
  const appData = getAppData (env);
  return (
    <AbsoluteGrid
      items={appData.Applications.filter (app => {
        console.log (app.type, type);
        return app.type === type;
      })}
      dragEnabled={true}
      responsive={true}
      verticalMargin={10}
      itemWidth={170}
      itemHeight={85}
      animation={''}
    />
  );
};

export default AppGrid;
